// Components
const ModalOrderDetails = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-order-details"*/ '@/app/views/main-view/dog-orders/containers/modals/modal-order-details/modal-order-details.vue');
const ModalDisapproveCancellationRequest = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-disapprove-cancellation-request"*/ '@/app/views/main-view/dog-orders/containers/modals/modal-disapprove-cancellation-request/modal-disapprove-cancellation-request.vue');

// Mixins
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js';
import { productMixins } from '@/app/mixins/modules/product-mixins';

// Constants
import { STATUS_CODES, TRANSACTION_STATUS } from '@/app/constants/constants';

// Services
import OrdersAPI from '@/app/services/main/orders/orders-service.js';

export default {
	name: 'OrdersContainer',
	components: {
		ModalOrderDetails,
		ModalDisapproveCancellationRequest
	},
	mixins: [
		tableMixins,
		productMixins,
		toastMessageMixins
	],
	data() {
		const statusList = [
			{
				id: 'For pickup',
				name: 'FOR PICKUP'
			},
			{
				id: 'For cancellation',
				name: 'FOR CANCELLATION'
			},
			{
				id: 'Cancelled',
				name: 'CANCELLED'
			},
			{
				id: 'FAILED',
				name: 'FAILED'
			},
			{
				id: 'Picked up',
				name: 'PICKED UP'
			}
		];

		return {
			isAPILoading: false,
			isCreatingTracker: false,
			modifyMode: '',
			selectedOrder: {},
			statusCodesConstants: TRANSACTION_STATUS,
			// table
			theads: [
				{ name: 'Order Number', searchLabel: 'f_id', sortLabel: 'createdAt', isDesc: false, hasSearch: true, style: null},
				{ name: 'User', searchLabel: 'f_fullName', sortLabel: 'fullName', isDesc: false, hasSearch: true, style: null},
				{ name: 'Address', searchLabel: 'f_shippingAddress', sortLabel: 'shippingAddress', isDesc: false, hasSearch: true, style: null},
				{ name: 'Price', searchLabel: 'f_totalPrice', sortLabel: 'totalPrice', isDesc: false, hasSearch: true, style: 'min-width: 150px'},
				{ name: 'Status', searchLabel: 'f_status', sortLabel: 'status', isDesc: false, hasSearchableDropdown: true, optionList: statusList, style: 'min-width: 225px'},
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: 'width: 170px'}
			],
			// sorting
			desc: true
		}
	},
	created() {
		this.getTableContent();
	},
	methods: {
		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
			page = fromFilter ? 1 : this.page;
			this.getOrdersList({ page, limit, sortBy, desc });
		},
		getOrdersList(queryParams) {
			// search filters
			if (this.columnsFilter) {
				const {
					f_id,
					f_fullName,
					f_shippingAddress,
					f_totalPrice,
					f_status,
				} = this.columnsFilter;

				if (f_id) {
					queryParams['f_id'] = f_id;
				}

				if (f_fullName) {
					queryParams['f_fullName'] = f_fullName;
				}

				if (f_shippingAddress) {
					queryParams['f_shippingAddress'] = f_shippingAddress;
				}

				if (f_totalPrice) {
					queryParams['f_totalPrice'] = f_totalPrice;
				}

				if (f_status) {
					queryParams['f_status'] = f_status;
				}
			}
			
			this.isAPILoading = true;

			OrdersAPI.getDogPurchaseOrders(queryParams)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination
						};
					} else {
						this.showAPIErrorToast('Unable to get order list.', res);
					}
					this.isAPILoading = false;
				})
				.catch(() => {
					this.showGenericErrorToast();
					this.isAPILoading = false;
				});
		},
		showModifyTrackingModal(order, mode) {
			this.selectedOrder = order;
			this.modifyMode = mode;

			setTimeout(() => {
				this.$refs.modalModifyTracking.openModal();
			}, 50);
		},
		showOrderDetailsModal(orderId) {
			this.$router.push(`dog-orders/${orderId}/view`);
		},
		showModalDisapprove(orderDetails) {
			this.$refs.modalDisapprove.openModal(orderDetails);
		},
		getClassByStatus(status) {
			const {
				REQUEST_CANCELLATION,
				CANCELLED,
				REFUNDED,
				DELIVERED,
				FAILED
			} = TRANSACTION_STATUS;

			switch (status) {
				case DELIVERED:
					return 'text-success';

				case REQUEST_CANCELLATION:
					return 'text-warning';

				case CANCELLED:
					return 'text-warning';
				
				case FAILED:	
				case REFUNDED:
					return 'text-danger';

				default:
					return 'text-primary';
			}
		},
		handleRefreshTableContent() {
			this.getTableContent(false);
		},
		showDeliveredConfirmationModal(orderId) {
			this.$swal({
				titleText: `Mark Order as Delivered`,
				html: `<p>Are you sure you want to mark order number <strong>${orderId}</strong> as <strong>DELIVERED</strong>?</p>`,
				confirmButtonText: 'Confirm',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				reverseButtons: true,
				showCloseButton: true
			})
			.then(result => {
				if (result.value) {
					this.isAPILoading = true;
					
					const bodyParams = { status:  TRANSACTION_STATUS.DELIVERED };
					const { SUCCESS_MARKED_ORDER_AS_DELIVERED, ERROR_MARK_ORDER_AS_DELIVERED } = this.toastMessages.order();

					// Call the API endpoint to update the order status
					OrdersAPI.putUpdateOrderStatus(orderId, bodyParams)
					.then(res => {
						if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							// Refresh table data
							this.getTableContent();

							// Show success message
							this.showCustomSuccessToast(SUCCESS_MARKED_ORDER_AS_DELIVERED);
						} else {
							// Show error message
							this.showAPIErrorToast(ERROR_MARK_ORDER_AS_DELIVERED, res);
						}

						this.isAPILoading = false;
					});
				}
			});
		},
		updateOrderStatus(orderId, orderStatus){
			this.$swal({
				titleText: `Mark Dog Purchase Order #${orderId} as ${orderStatus}`,
				html: `<p style='color: #ff801e; margin: .75rem 0 .25rem 0;'>Are you sure you want to update the dog purchase order status to <strong style='color: #ff801e'>${orderStatus.toUpperCase()}</strong>?</p>`,
				confirmButtonText: 'Confirm',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				reverseButtons: true,
				showCloseButton: true
			})
			.then(result => {
				if (result.value) {
					this.isAPILoading = true;

					const body = { status:  orderStatus };
					
					const { ERROR_MARK_ORDER_AS_PICKED_UP, ERROR_MARK_ORDER_AS_REFUNDED } = this.toastMessages.order();

					const errorMessage = orderStatus === TRANSACTION_STATUS.PICKED_UP ? ERROR_MARK_ORDER_AS_PICKED_UP : ERROR_MARK_ORDER_AS_REFUNDED


					OrdersAPI.putUpdateOrderStatus(orderId, body)
					.then(response => {
						if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							this.getTableContent()
							this.showCustomSuccessToast(`Successfully updated Dog Purchase Order #${orderId} status to ${orderStatus}`);
						} else {
							this.showAPIErrorToast(errorMessage, response)
						}
					})
				}
			})
		}
	}
}